// src/App.js
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'; // ✅ v5 imports

// ===== REGULAR PAGES =====
import HomePage from './pages/homepage/homepage.component';
import ShopPage from './pages/shop/shop.component';
import CheckoutPage from './pages/checkout/checkout.component';
import SignInAndSignUp from './pages/sign-in-sign-up/sign-in-sign-up.component';
import HairTransplant from './pages/hair-transplant/hair-transplant.component';
import HairCenters from './pages/hair-centers/hair-centers.component';
import MenWigs from './pages/men-wigs/men-wigs.component';
import LadyHair from './pages/lady-hair/lady-hair.component';
import NewArrivals from './pages/new-arrivals/new-arrivals.component';
import Accessories from './pages/accessories/accessories.component';
import Articles from './pages/articles/articles.component';
import AdminOrders from './pages/admin-orders/admin-orders.component';
import ArticleDetail from './pages/article-detail/article-detail.component';

// ===== ADMIN PAGES =====
import AdminLogin from './pages/admin/admin-login.component';
import AdminPanel from './pages/admin/admin.component';
import AdminAppointments from './pages/admin-appointments/admin-appointments.component';
import OrderTracking from './pages/order-tracking/order-tracking.component';

// ===== COMPONENTS =====
import Header from './components/header/header.component';
import Footer from './components/footer/footer.component';

// ===== REDUX =====
import { createStructuredSelector } from 'reselect';
import { auth, createUserProfileDocument, onAuthStateChanged } from "./firebase/firebase.utils";
import { connect } from 'react-redux';
import { setCurrentUser } from './redux/user/user.actions';
import { selectCurrentUser } from './redux/user/user.selector';

// ===== STYLES =====
import "./App.css";

class App extends React.Component {
  unsubscribeFromAuth = null

  componentDidMount() {
    const { setCurrentUser } = this.props

    this.unsubscribeFromAuth = onAuthStateChanged(auth, async userAuth => {
      if (userAuth) {
       
        setCurrentUser(userAuth)
      }
      setCurrentUser(userAuth)
    })
  }

  componentWillUnmount() {
    if (this.unsubscribeFromAuth) {
      this.unsubscribeFromAuth()
    }
  }

  render() {
    return (
      <div>
        <Header />
        <Switch>
          {/* ===== HOME & SHOP ===== */}
          <Route exact path="/" component={HomePage} />
          <Route path="/shop" component={ShopPage} />
          <Route exact path='/checkout' component={CheckoutPage} />
          
          {/* ===== FIXED: Article route with v5 syntax ===== */}
          <Route path="/article/:slug" component={ArticleDetail} />
 
          {/* ===== PRODUCT PAGES ===== */}
          <Route path="/hair-transplant" component={HairTransplant} />
          <Route path="/hair-centers" component={HairCenters} />
          <Route path="/men-wigs" component={MenWigs} />
          <Route path="/lady-hair" component={LadyHair} />
          <Route path="/new-arrivals" component={NewArrivals} />
          <Route path="/accessories" component={Accessories} />
          <Route path="/articles" component={Articles} />
          

          {/* ===== ADMIN ROUTES ===== */}
          <Route path="/admin-login" component={AdminLogin} />
          <Route path="/admin-appointments" component={AdminAppointments} />
          <Route path="/admin" component={AdminPanel} />
          <Route path="/admin-orders" component={AdminOrders} />
          <Route path="/track-order" component={OrderTracking} />

          {/* ===== AUTH ===== */}
          <Route
            exact
            path="/signin"
            render={() =>
              this.props.currentUser ? (
                <Redirect to='/' />
              ) : (
                <SignInAndSignUp />
              )
            }
          />

          {/* ===== REDIRECT ===== */}
          <Redirect to="/" />
        </Switch>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser
})

const mapDispatchToProps = dispatch => ({
  setCurrentUser: user => dispatch(setCurrentUser(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(App);